export default [
  {
    path: "/chat-page",
    name: "chat-page",
    component: () => import("@/views/chatPage/View.vue"),
    meta: {
      pageTitle: "breadcrumb.chatPage",
      navActiveLink: "chat-page",
      resource: "chat-page",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.chatPage",
          active: true,
        },
      ],
    },
  },
];
``;
